'use client';

import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { SITE } from '@/app/constants';
import { cn, reportEvent } from '@/app/utils';
import { useLocale, useRouter } from '@/i18n/routing';

const VIDU_STREAM_PATH = '/vidu-stream';

const BANNER_ASSETS =
  SITE === 'global'
    ? {
        bg: 'https://image01.cf.vidu.studio/vidu/media-asset/s1_bg-1d745d40.webp',
        cards: 'https://image01.cf.vidu.studio/vidu/media-asset/s1_icon-cc57ff6c.webp',
      }
    : ({
        bg: 'https://image01.vidu.zone/vidu/media-asset/s1_bg-1d745d40.webp',
        cards: 'https://image01.vidu.zone/vidu/media-asset/s1_icon-cc57ff6c.webp',
      } as const);

const COPY = {
  zh: {
    title: 'Vidu S1',
    lead: '全球领先的实时交互视频模型上线，创建你的角色，免费开启互动',
    cta: '立即体验',
  },
  en: {
    title: 'Vidu S1: ',
    lead: 'the best stream real-time, interactive next-gen video model, is now live, create your character and start your free interaction experience',
    cta: 'Try Now',
  },
} as const;

export const ViduS1Banner = ({ onClose, className }: { onClose: () => void; className?: string }) => {
  const locale = useLocale();
  const router = useRouter();
  const copy = COPY[locale === 'zh' ? 'zh' : 'en'];

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    reportEvent('element_click', { element_name: 'vidu_s1_top_banner_close' });
    onClose();
  };

  const goViduStream = (elementName: string) => {
    reportEvent('element_click', { element_name: elementName });
    router.push(VIDU_STREAM_PATH);
  };

  const handleBarClick = () => {
    goViduStream('vidu_s1_top_banner_main');
  };

  const handleCtaClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    goViduStream('vidu_s1_top_banner_cta');
  };

  return (
    <div
      className={cn(
        'relative isolate flex h-[60px] w-full cursor-pointer items-center justify-between overflow-hidden bg-[rgba(47,51,83,0.5)] px-4',
        className,
      )}
      onClick={handleBarClick}
    >
      <div className="pointer-events-none absolute inset-0">
        <img src={BANNER_ASSETS.bg} alt="" className="h-full w-full object-cover" />
      </div>

      <div className="relative z-10 flex h-full min-w-0 flex-1 items-center justify-center gap-3 overflow-hidden">
        <div className="flex h-full min-w-0 items-center gap-2 overflow-hidden whitespace-nowrap text-sm text-white leading-[1.4]">
          <img
            src={BANNER_ASSETS.cards}
            alt=""
            width={90}
            height={48}
            className="mr-1 h-12 w-[90px] shrink-0 self-end sm:hidden"
          />
          <span className="shrink-0 font-semibold">{copy.title}</span>
          <span className="min-w-0 truncate">{copy.lead}</span>
        </div>

        <div className="h-[14px] w-px shrink-0 bg-system-white16 sm:hidden" />

        <button
          type="button"
          onClick={handleCtaClick}
          className="shrink-0 cursor-pointer rounded-[8px] border-0 bg-black px-3 py-1 font-semibold text-white text-xs leading-[1.4] transition-colors hover:bg-black/80 sm:hidden"
        >
          {copy.cta}
        </button>
      </div>

      <button
        type="button"
        onClick={handleClose}
        className="relative z-10 shrink-0 text-white transition-colors hover:text-white/80"
        aria-label="Close"
      >
        <BaseLineClose className="size-4" />
      </button>
    </div>
  );
};
